<template>
  <div class="content-scoll">
    <div class="pupils-card">
      <div>
        <!-- <h5 v-if="group_id">{{'disciplines' | setText('Предметы')}}</h5> -->
        <ul class="pupils-list">
            <li 
              v-for="journal in journals" :key="journal.id"
              @click="current=journal" 
              :class="`${current && journal.id==current.id ? 'active' : ''}`" 
              class="pupils-list-item"
              :style="`--color-card: ${journal.color}`"
            >
              <img :src="journal.icon">
              <span>{{ journal.title }}</span>
            </li>
        </ul>
      </div>
        <div class="area-wrapper scrolly-borders">
          <div class="area">
            <timetables v-if="current" :group_id="group_id"  :discipline_id="current.id"/>
          </div>
        </div>
    </div>
    </div>
</template>
<script>
import timetables from '@/components/Pupils/Journal/Timetables';
import {getJournal} from '@/_api/apiPupil';
export default {
  props: {
    group_id: {
      default:null
    }
  },
  components: {
    timetables
  },
  created(){
      this.getJournal(this.group_id);
  },
  watch: {
    group_id(val){
      this.current   = null;
      this.getJournal(val);
    },
  },
  methods: {
  getJournal:getJournal
  },
  data() {
    return {
       journals:[],
       current : null,
    };
  },
};
</script>

